<template>
	<div class="filterPage">
		<div v-if="displayedPress" class="filterPage__bottom">
			<div class="filterPage__bottomWrapper">
				<div
					v-for="(item, index) in displayedPress"
					:key="index"
					class="filterPage__gridItem gridItem redactorStyles"
				>
					<a tabindex="0" :href="item.data.url">
						<div class="gridItem__imgCont">
							<img v-if="item.image" :src="item.image" :alt="item.data.title" />
						</div>
					</a>
					<h4 class="gridItem__title">{{ item.data.title }}</h4>
					<p v-if="item.data.postDate" class="gridItem__p">
						{{ item.data.postDate }}
					</p>
					<p v-if="item.data.readTime" class="gridItem__readTime">
						{{ item.data.readTime }}
					</p>
					<div class="gridItem__buttons buttons">
						<div class="prmBtn prmBtn--darkOutline">
							<a tabindex="0" :href="item.data.url">
								<p>Read now</p>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="total > count"
				@click="getMoreElements"
				class="filterPage__getMore"
			>
				<div class="filterPage__getMoreButton">
					<p>Show More</p>
					<ShowMore></ShowMore>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import ShowMore from './svg/ShowMore';

export default {
	name: 'Press',
	components: {
		ShowMore,
	},
	data() {
		return {
			displayedPress: null,
			dataRendered: null,
			perPage: 12,
			total: null,
			count: null,
		};
	},

	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			let that = this;
			$.get(
				'/api/v1/press',
				{
					perPage: that.perPage,
				},
				function (res) {
					that.dataRendered = res.data;
					that.total = res.meta.pagination.total;
					that.count = res.meta.pagination.count;
				}
			);
		},
		getDateProperties() {
			this.displayedPress = [];
			this.dataRendered.forEach((el) => {
				let date = new Date(el.data.postDate.date);
				let month = date.toLocaleString('default', { month: 'long' });
				let day = date.getDate();
				let year = date.getFullYear();
				el.data.postDate = `${month} ${day}, ${year}`;
				this.displayedPress.push(el);
			});
		},
		getMoreElements() {
			this.perPage += 12;
		},
	},
	watch: {
		perPage() {
			this.getData();
		},
		dataRendered() {
			if (!this.dataRendered) {
				return;
			}
			this.getDateProperties();
		},
	},
};
</script>
